import React from 'react';
import classnames from 'classnames';
import { PropTypes } from 'prop-types';

const ProgressBar = ({
  completedSteps,
  totalSteps,
  clickHandler,
  currentStep,
  canEditPage,
}) => {
  const steps = [];
  for (let i = 0; i < totalSteps; i++) {
    steps.push(i);
  }

  const activeItemClass = canEditPage
    ? 'ccm-progress-bar__item--active'
    : 'ccm-progress-bar__item--disabled';

  return (
    <div className="ccm-progress-bar">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`ccm-progress-bar__item ${
            currentStep === step ? activeItemClass : ''
          }`}
        >
          {!completedSteps.includes(step) ? (
            <button
              onClick={() => clickHandler(step)}
              className={classnames('ccm-progress-bar__not-completed', {
                'ccm-progress-bar__not-completed-disabled': !canEditPage,
              })}
            >
              <div
                className={classnames(
                  'ccm-progress-bar__not-completed-circle',
                  {
                    'ccm-progress-bar__not-completed-circle-disabled':
                      !canEditPage,
                  },
                )}
              />
            </button>
          ) : (
            <button
              onClick={() => clickHandler(step)}
              className="ccm-progress-bar__completed"
            >
              <div
                className={classnames('ccm-progress-bar__completed-circle', {
                  'ccm-progress-bar__not-completed-circle-disabled':
                    !canEditPage,
                })}
              >
                <div className="ccm-progress-bar__completed-check-mark" />
              </div>
            </button>
          )}
          <div
            className={classnames('ccm-progress-bar__decor', {
              'ccm-progress--progress-bar__completed': !canEditPage,
              'ccm-progress-bar__decor-disabled': !canEditPage,
            })}
          />
        </div>
      ))}
    </div>
  );
};

ProgressBar.propTypes = {
  completedSteps: PropTypes.array.isRequired,
  totalSteps: PropTypes.number.isRequired,
  clickHandler: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  canEditPage: PropTypes.bool,
};

export default ProgressBar;
